module.exports = __webpack_public_path__ + "static/img/par14.39751f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par14.png
// module id = pcsl
// module chunks = 0